export const MINIMUM_BANK_STATEMENT = 24603;
export const POSTAL_ADDRESS_AUTOFILL = 1;
export const POSTAL_ADDRESS_MANUAL = 2;

export const APPLICANT_TYPE_INDIVIDUAL = 1;
export const APPLICANT_TYPE_PARTNERSHIP = 2;
export const APPLICANT_TYPE_COMPANY = 3;
export const APPLICANT_TYPE_TRUST = 4;

export const OWNERSHIP_OWNS_OUTRIGHT = 1;
export const OWNERSHIP_MORTGAGE = 2;
export const OWNERSHIP_RENTS = 3;
export const OWNERSHIP_LIVES_WITH_RELATIVES = 4;

export const APPLICATION_COMMERCIAL = 1;
export const APPLICATION_RESIDENTIAL = 2;
export const APPLICATION_SUPPLIER_ACCREDITATION = 3;
export const APPLICATION_CAR = 4;
export const APPLICATION_STOCK_FINANCE = 5;

export const ASSET_CONDITION_NEW = 1;
export const ASSET_CONDITION_USED = 2;
export const ASSET_CONDITION_DEMO = 3;

export const TYPE_SALE_ASSET_CONDITION_DEALER = 1;
export const TYPE_SALE_ASSET_CONDITION_PRIVATE = 2;

export const INCOME_TYPE_SELF_EMPLOYED = 12;
export const INCOME_FULL_TIME_TYPE = 1;
export const INCOME_PART_TIME_TYPE = 2;
export const INCOME_CASUAL = 3;
export const INCOME_DIVIDENDS = 8;
export const INCOME_OTHER = 10;
export const INCOME_INVESTMENT_PROPERTY = 11;
export const INCOME_PENSION = 13;

export const INCOME_PERMANENT_TYPES_GROUP = [INCOME_FULL_TIME_TYPE, INCOME_PART_TIME_TYPE, INCOME_CASUAL];
export const INCOME_OTHER_TYPES_GROUP = [
    INCOME_OTHER, INCOME_INVESTMENT_PROPERTY, INCOME_DIVIDENDS, INCOME_PENSION
];

export const CITIZEN_STATUS = 1;
export const PERMANENT_RESIDENT_STATUS = 2;
export const VISA_STATUS = 3;

export const INCOME_INCOME_TYPES = {
    [INCOME_FULL_TIME_TYPE]: "Full time",
    [INCOME_PART_TIME_TYPE]: "Part time",
    [INCOME_CASUAL]: "Casual",
    [INCOME_PENSION]: 'Pension',
    [INCOME_TYPE_SELF_EMPLOYED]: "Self Employed",
    [INCOME_INVESTMENT_PROPERTY]: "Investment Property",
    [INCOME_DIVIDENDS]: "Dividends",
    [INCOME_OTHER]: "Other",
};

export const PRODUCT_DETAIL_ALL = 1;
export const PRODUCT_DETAIL_PARTIAL = 2;
export const PRODUCT_DETAIL_NONE = 2;
export const PRODUCT_STATUS_NEW = 2;
export const PRODUCT_STATUS_USED = 2;
export const PRODUCT_STATUS_DEMO = 3;

export const COMMITMENT_HOME_TYPE = 1;
export const COMMITMENT_INVESTMENT_TYPE = 2;
export const COMMITMENT_CAR_TYPE = 3;
export const COMMITMENT_CREDIT_CARD_TYPE = 4;
export const COMMITMENT_OTHER_TYPE = 5;
export const COMMITMENT_PERSONAL_TYPE = 6;

export const PAYSLIP_TYPE = 1;
export const BANK_STATEMENT_TYPE = 2;
export const PROPOSAL_TYPE = 3;